<template>
  <div>
    <van-popup v-model="IsAccountShow"
               class="account_pop"
               z-index='2'
               id="switch_account_box">
      <div>
        <div class="switch_account_title">切换账号</div>
        <van-icon name="cross"
                  @click="onAccountClose"
                  color="#999"
                  size="18px"
                  style="position: absolute;z-index: 10;top: 16px;right: 16px;" />
      </div>

      <div class="switch_account_list">
        <div class="switch_account_item"
             v-for="(item,index) in accountList"
             :key="index"
             :class="[item.isCurrent ? 'active' : 'unactive']"
             @click="changeAccount(item,index)">

          <div class="switch_account_item_left">
            <img v-if="item.avatarUrl != null && item.avatarUrl && item.avatarUrl"
                 mode="aspectFill"
                 class="switch_account_item_sculpture"
                 :src="item.avatarUrl" />

            <img class="switch_account_item_sculpture"
                 v-else
                 src="../../../assets/images/default.jpeg"
                 alt="" />
            <div class="switch_account_item_desc">
              <div>
                <svg class="switch_account_icon_f"
                     v-if="item.isPrimary"
                     aria-hidden="true">
                  <use xlink:href="#icon-zhuzhanghaotubiao"></use>
                </svg>
                <svg class="switch_account_icon_f"
                     v-else
                     aria-hidden="true">
                  <use xlink:href="#icon-zizhanghaotubiao"></use>
                </svg>
                <span class="switch_account_item_name">{{item.nickName}}</span>
              </div>
              <div class="switch_account_item_code">
                会员编号：{{item.account}}
              </div>
            </div>

          </div>
          <div class="switch_account_item_right">
            <svg class="switch_account_icon"
                 v-if="! item.isCurrent"
                 aria-hidden="true">
              <use xlink:href="#icon-qiehuanzhanghaotubiao"></use>
            </svg>
            切换账号
          </div>
        </div>

      </div>
    </van-popup>

    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>

</template>

<script>
import {
  Tab,
  Tabs,
  Toast,
  Dialog,
  List,
  Loading,
  Overlay,
  Popup,
  Icon,
  Picker
} from "vant";
import loading from "../../components/loading/loading";
import service from "../../api/myShare/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [List.name]: List,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    loading,
  },
  props: {
    // accountMessage: {
    //   type: String,
    //   required: true,
    // }
  },
  data () {
    return {
      IsAccountShow: true,
      accountList: [],
      isLoading: true, //loading状态
      clearItem: true, //清除字段
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 切换账号关闭
    onAccountClose () {
      this.IsAccountShow = false
    },
    // 切换账号关闭
    changeAccount (item, index) {
      for (let i = 0; i < this.accountList.length; i++) {
        if (index == i) {
          this.accountList[i].isCurrent = true
        } else {
          this.accountList[i].isCurrent = false
        }
      }
      let items = {
        subUserId: item.subUserId,
        clearItem: this.clearItem
      }
      this.$emit('change', items);
      this.IsAccountShow = false
    },
    // 获取账号列表
    getList () {
      this.isLoading = true
      service.accountList().then(res => {
        if (res.statusCode == 200) {
          this.accountList = res.data
          this.clearItem = true
          this.isLoading = false
        } else {
          this.isLoading = false
          this.clearItem = false

          Toast(res.errors);
        }
      })
    }
  },
  created () { },
  mounted () {
    this.getList()
  }
};
</script>
<style lang="less" scoped>
// 折叠版样式
@deep: ~'>>>';
#switch_account_box {
  height: 296px;
  width: 351px;
  border-radius: 8px;
  .unactive {
    border: 1px solid #ececec;
  }
  .active {
    border: 1px solid #f00724;
  }
  .switch_account_icon_f {
    width: 14px;
    height: 14px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 6px;
  }
  .switch_account_icon {
    width: 12px;
    height: 10px;
    margin-right: 6px;
  }
  .switch_account_title {
    text-align: center;
    width: 100%;
    margin: 16px 0;
    height: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 16px;
  }
  .switch_account_list {
    padding: 0 12px;
    height: auto;
    .switch_account_item {
      height: 46px;
      background: #ffffff;
      box-shadow: 0px 4px 8px 0px #e6e6e6;
      border-radius: 8px;
      // border: 1px solid #ececec;
      margin-bottom: 8px;
      padding: 12px;
      .switch_account_item_left {
        float: left;
        .switch_account_item_sculpture {
          float: left;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: 12px;
        }
        .switch_account_item_desc {
          float: left;
          .switch_account_item_name {
            display: inline-block;
            vertical-align: bottom;
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 14px;
            margin-top: 4px;
          }
          .switch_account_item_code {
            height: 12px;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            line-height: 12px;
            margin-top: 12px;
          }
        }
      }
      .switch_account_item_right {
        float: right;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        font-size: 14px;
        font-weight: 400;
        color: #f00724;
      }
    }
  }
}
</style>